import React from 'react';
import { connect } from 'react-redux';
import { Grid} from 'semantic-ui-react';
import { map as _map } from 'lodash';
import 'react-phone-input-2/lib/style.css'
import { getProfile, updateProfile } from '../../services/Seller';
import './ProfileContainer.less';
import { setActiveMenuItem } from '../../store/actions/actions';
import { showNotificationMessage } from '../../store/actions/reactNotification'
import { SUCCESS, ERROR } from '../../constants/NotificationType';
import DGTextbox from 'components/FormControls/Textbox/DGTextbox'
import Formsy from 'formsy-react';
import servicegrace from '../../assets/images/newui/servicegrace.svg'
import next from '../../assets/images/newui/sellersignup/next-btn.svg'
import GeneralMessage from '../../components/GeneralMessage/GeneralMessage';
import { format, normalize } from 'react-phone-input-auto-format';
import { formatPhone, unFormatPhone } from '../../helpers/parsePhone';
import { addValidationRule } from 'formsy-react';
import { isNotBlankString, isValidCellNumber } from '../../helpers/validation';
import loader from '../../assets/images/newui/loader.gif'
import DGAddressAutoFill from '../../components/FormControls/AddressAutofill/DGAddressAutoFill';

addValidationRule('isNotBlankString', isNotBlankString);
addValidationRule('isValidCellNumber', isValidCellNumber);
class ProfileContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            profile: {},
            states: [],
            services: [],
            phone: '',
            name: '',
            address: '',
            message: '',
            messageType: 'error',
            saving: false
            
        }
    }

    async componentDidMount() {
        console.log('componentdidmount');
        const profileResponse = await getProfile();
        if(profileResponse.resStatus == 200){
            const profile = profileResponse.data;
            
            if(profile){
                let phone = profile.cellPhone;
                phone = unFormatPhone(phone);
                phone = format(phone);

                const address = `${_.trim(profile.addressline1)}, ${profile.city}, ${profile.stateAbbreviation} ${profile.zip}`

                this.setState({ phone: phone, name: profile.name, address: address});
            }
            
        }
        
        /*getStates().then((states) => {
            this.setState({ states: states.data })
        });
        getSellerServices().then((services) => this.setState({ services: services.data }));*/
    }

    get states() {
        const { states } = this.state;
        return _map(states, s => {
            return { key: s.stateID, text: s.name, value: s.stateID };
        });
    }

    save = () => {
        const { profile } = this.state;
        updateProfile(profile)
            .then(() => {
                this.props.showNotificationMessage(SUCCESS, 'Profile updated successfully.');
                console.log('Saved')
            })
            .catch(() => {
                this.props.showNotificationMessage(ERROR, 'Profile update failed.');
                console.log('failed')
            });
    }

    /*handleChange = (e, { name, value }) => {
        console.log(e, name, value);
        let { profile } = this.state;
        profile[name] = value;
        this.setState({ profile });
    }*/

    handleChange = (e, { name, value }) => {
        this.setState({ [name]: value });
    }

    handlePhoneChange = (e, { value }) => {
        this.setState({ phone: format(value), errorMsg: '' });
    }

    onPhoneKeyDown = (evt) => {
        if (evt.key != 'Backspace' && evt.key != 'Delete' && evt.key != 'Tab') {
            var patt = new RegExp(/^[0-9\b]+$/);
            var res = patt.test(evt.key);
            if (!res)
                evt.preventDefault()
        }
    }

    onValidSubmit = async (formValue) => {
        this.setState({
            saving: true
        })
        let phone = normalize(this.state.phone);
        phone = formatPhone(phone);
        const updateProfileResponse = await updateProfile(this.state.name, formValue.address, phone);
        if (updateProfileResponse.resStatus == 200) {
            this.setState({message: 'Business profile saved successfully.', messageType: 'success', saving: false})
        }
        else {
            this.setState({message: 'Error updating profile.', messageType: 'error', saving: false})
        }
    }

    render() {
        //const { profile, services } = this.state;
        
        return (<>
           
            <div className='small-form-container'>
                <img src={servicegrace} />
                <div className='small-form-heading'>ServiceGrace</div>
                <div className='small-form-sub-heading'>Update Your Profile</div>
                {this.state.message && <GeneralMessage message={this.state.message} type={this.state.messageType} />}
                
                <Formsy onValidSubmit={this.onValidSubmit} className='small-form-form'>
                    <Grid>
                    <Grid.Column width={16}>
                    
                    <DGTextbox name="name" label="Business Name" placeholder="" required type="text"
                        focus={true}
                        maxLength={200}
                        tabIndex={1}
                        validationErrors={{
                            isDefaultRequiredValue: 'Business Name is required',
                            
                        }}
                        onChange={this.handleChange}
                        value={this.state.name}
                    />
                </Grid.Column>
                    <Grid.Column mobile={16} tablet={16} computer={16}>
                    <DGTextbox name="phone" label="Phone Number" placeholder="" required type="text"
                        focus={true}
                        maxLength={14}
                        tabIndex={1}
                        validations={{
                            isValidCellNumber: true
                        }}
                        validationErrors={{
                            isDefaultRequiredValue: 'Phone Number is required',
                            isValidCellNumber: 'Invalid Cell Number'
                        }}
                        onChange={this.handleChange}
                        onKeyDown={this.onPhoneKeyDown}
                        value={!_.isEmpty(this.state.phone) ? format(this.state.phone) : ''}
                    />
                </Grid.Column>
                <Grid.Column mobile={16} tablet={16} computer={16}>
                    {/*<DGTextbox
                        tabIndex={2}
                        placeholder="" name="address" label="Business Address" required
                        maxLength={300}
                        onChange={this.handleChange}
                        validationErrors={{
                            isDefaultRequiredValue: 'Business Address is required',
                            isNotBlankString: `Business Address is required`,

                        }}
                        validations={{
                            isNotBlankString: true
                        }}
                        value={this.state.address}
                    />*/}
                    <DGAddressAutoFill
                        scrollableParentSelector='.small-form-form'
                        innerRef={(c) => {
                            console.log(c);
                        }}
                        onblur={(e) => this.onScroll(e, true)}
                        onfocus={() => {
                            this.onScroll();
                            if (window.innerWidth < 768
                                //&&  !this.isInViewport(document.getElementById("field_"+field.fieldID) , 0)
                            ) {
                                /*setTimeout(() => {
                                    document.getElementById("field_" + field.fieldID).scrollIntoView({
                                        behavior: 'smooth',
                                        //block: 'nearest', 
                                        inline: 'center'
                                    });
                                }, 50);*/
                            }
                        }
                        }
                        name="address"
                        label='Business Address'
                        placeholder=''
                        required
                        value={this.state.address}
                        validationErrors={{
                            isDefaultRequiredValue: `Business address is required`

                        }}

                    />
                </Grid.Column>
                        
                        <button className='small-form-submit' tabIndex={6} type='submit' {...{
                            disabled: this.state.saving
                        }}>Save <img src={next} />{this.state.saving && <img src={loader} style={{width: '16px', height: 'auto'}} />}</button>

                    </Grid>
                </Formsy>
            </div>
        </>
        );
    }
}
const mapStateToProps = ({ }) => {
    return {};
}

const mapDispatchToProps = {
    showNotificationMessage, setActiveMenuItem,
}

export default connect(mapStateToProps, mapDispatchToProps)(ProfileContainer);